module.exports = __webpack_public_path__ + "img/xinxihua.99fe4985.png";